module.exports = __webpack_public_path__ + "static/assets/5306d1506a03db52b6f918de4c809ca7.svg";